import React from "react";
import { IconTimes } from "../icons/Icons";

const Modal = ({
  isOpen,
  onClose,
  isModal,
  children,
  title,
  modalSize = "lg",
}) => {
  if (!isOpen || isModal) {
    return null;
  }

  return (
    <div className="fixed bg-zinc-700/50 inset-0 flex items-start justify-center z-[100] overflow-y-scroll">
      <div
        className={`relative bg-white rounded-lg p-6 my-5 shadow-lg ${
          modalSize === "lg" ? "w-10/12" : "w-11/12 md:w-5/12"
        }`}
      >
        <button
          className="absolute top-0 right-0 mt-4 mr-4 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          <IconTimes className="w-6" />
        </button>
        <h2 className="text-lg font-medium uppercase mb-4">{title}</h2>
        {children}
      </div>
    </div>
  );
};

export default Modal;
